import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext(null);

const translations = {
  es: {
    // General
    app_name: 'Regulisto',
    loading: 'Cargando...',
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    create: 'Crear',
    search: 'Buscar',
    filter: 'Filtrar',
    export: 'Exportar',
    actions: 'Acciones',
    confirm: 'Confirmar',
    back: 'Volver',
    close: 'Cerrar',
    yes: 'Sí',
    no: 'No',
    
    // Auth
    login: 'Iniciar Sesión',
    logout: 'Cerrar Sesión',
    register: 'Registrarse',
    email: 'Correo electrónico',
    password: 'Contraseña',
    name: 'Nombre',
    welcome_back: 'Bienvenido de nuevo',
    sign_in_to_continue: 'Inicia sesión para continuar',
    dont_have_account: '¿No tienes cuenta?',
    already_have_account: '¿Ya tienes cuenta?',
    
    // Navigation
    dashboard: 'Panel',
    employees: 'Empleados',
    time_records: 'Fichajes',
    shifts: 'Turnos',
    calendars: 'Calendarios',
    vacations: 'Vacaciones',
    absences: 'Ausencias',
    locations: 'Ubicaciones',
    reports: 'Informes',
    settings: 'Configuración',
    kiosk: 'Kiosko',
    
    // Dashboard
    total_employees: 'Total Empleados',
    records_today: 'Fichajes Hoy',
    pending_vacations: 'Vacaciones Pendientes',
    active_absences: 'Ausencias Activas',
    recent_activity: 'Actividad Reciente',
    quick_actions: 'Acciones Rápidas',
    
    // Employees
    add_employee: 'Añadir Empleado',
    employee_name: 'Nombre del Empleado',
    department: 'Departamento',
    position: 'Cargo',
    hire_date: 'Fecha de Contratación',
    pin: 'PIN',
    active: 'Activo',
    inactive: 'Inactivo',
    
    // Time Records
    clock_in: 'Entrada',
    clock_out: 'Salida',
    break_start: 'Inicio Descanso',
    break_end: 'Fin Descanso',
    timestamp: 'Fecha/Hora',
    location_valid: 'Ubicación Válida',
    location_invalid: 'Ubicación Inválida',
    
    // Shifts
    shift_templates: 'Plantillas de Turno',
    shift_assignments: 'Asignaciones',
    shift_sequences: 'Secuencias',
    start_time: 'Hora Inicio',
    end_time: 'Hora Fin',
    create_template: 'Crear Plantilla',
    assign_shift: 'Asignar Turno',
    night_shift: 'Turno Nocturno',
    
    // Calendar
    work_calendar: 'Calendario Laboral',
    holidays: 'Festivos',
    add_holiday: 'Añadir Festivo',
    national_holiday: 'Festivo Nacional',
    local_holiday: 'Festivo Local',
    year: 'Año',
    
    // Vacations
    request_vacation: 'Solicitar Vacaciones',
    start_date: 'Fecha Inicio',
    end_date: 'Fecha Fin',
    days: 'Días',
    status: 'Estado',
    pending: 'Pendiente',
    approved: 'Aprobado',
    rejected: 'Rechazado',
    approve: 'Aprobar',
    reject: 'Rechazar',
    notes: 'Notas',
    
    // Absences
    sick_leave: 'Baja Médica',
    personal: 'Personal',
    other: 'Otro',
    absence_type: 'Tipo de Ausencia',
    register_absence: 'Registrar Ausencia',
    
    // Locations
    add_location: 'Añadir Ubicación',
    address: 'Dirección',
    latitude: 'Latitud',
    longitude: 'Longitud',
    radius: 'Radio (metros)',
    
    // Reports
    generate_report: 'Generar Informe',
    date_range: 'Rango de Fechas',
    export_excel: 'Exportar Excel',
    export_csv: 'Exportar CSV',
    worked_hours: 'Horas Trabajadas',
    extra_hours: 'Horas Extra',
    night_hours: 'Horas Nocturnas',
    sunday_holiday_hours: 'Horas Domingo/Festivo',
    
    // Kiosk
    enter_pin: 'Introduce tu PIN',
    clock_action: 'Selecciona una acción',
    success: 'Éxito',
    error: 'Error',
    invalid_pin: 'PIN inválido',
    record_saved: 'Fichaje registrado',
    
    // Roles
    admin: 'Administrador',
    supervisor: 'Supervisor',
    worker: 'Trabajador',
    inspector: 'Inspector',
    
    // Messages
    confirm_delete: '¿Estás seguro de que deseas eliminar?',
    saved_successfully: 'Guardado correctamente',
    deleted_successfully: 'Eliminado correctamente',
    error_occurred: 'Ha ocurrido un error',
    no_results: 'No hay resultados',
    
    // Time
    today: 'Hoy',
    yesterday: 'Ayer',
    this_week: 'Esta Semana',
    this_month: 'Este Mes',
    hours: 'horas',
    minutes: 'minutos',
  },
  en: {
    // General
    app_name: 'Regulisto',
    loading: 'Loading...',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    search: 'Search',
    filter: 'Filter',
    export: 'Export',
    actions: 'Actions',
    confirm: 'Confirm',
    back: 'Back',
    close: 'Close',
    yes: 'Yes',
    no: 'No',
    
    // Auth
    login: 'Login',
    logout: 'Logout',
    register: 'Register',
    email: 'Email',
    password: 'Password',
    name: 'Name',
    welcome_back: 'Welcome back',
    sign_in_to_continue: 'Sign in to continue',
    dont_have_account: "Don't have an account?",
    already_have_account: 'Already have an account?',
    
    // Navigation
    dashboard: 'Dashboard',
    employees: 'Employees',
    time_records: 'Time Records',
    shifts: 'Shifts',
    calendars: 'Calendars',
    vacations: 'Vacations',
    absences: 'Absences',
    locations: 'Locations',
    reports: 'Reports',
    settings: 'Settings',
    kiosk: 'Kiosk',
    
    // Dashboard
    total_employees: 'Total Employees',
    records_today: 'Records Today',
    pending_vacations: 'Pending Vacations',
    active_absences: 'Active Absences',
    recent_activity: 'Recent Activity',
    quick_actions: 'Quick Actions',
    
    // Employees
    add_employee: 'Add Employee',
    employee_name: 'Employee Name',
    department: 'Department',
    position: 'Position',
    hire_date: 'Hire Date',
    pin: 'PIN',
    active: 'Active',
    inactive: 'Inactive',
    
    // Time Records
    clock_in: 'Clock In',
    clock_out: 'Clock Out',
    break_start: 'Break Start',
    break_end: 'Break End',
    timestamp: 'Timestamp',
    location_valid: 'Valid Location',
    location_invalid: 'Invalid Location',
    
    // Shifts
    shift_templates: 'Shift Templates',
    shift_assignments: 'Assignments',
    shift_sequences: 'Sequences',
    start_time: 'Start Time',
    end_time: 'End Time',
    create_template: 'Create Template',
    assign_shift: 'Assign Shift',
    night_shift: 'Night Shift',
    
    // Calendar
    work_calendar: 'Work Calendar',
    holidays: 'Holidays',
    add_holiday: 'Add Holiday',
    national_holiday: 'National Holiday',
    local_holiday: 'Local Holiday',
    year: 'Year',
    
    // Vacations
    request_vacation: 'Request Vacation',
    start_date: 'Start Date',
    end_date: 'End Date',
    days: 'Days',
    status: 'Status',
    pending: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
    approve: 'Approve',
    reject: 'Reject',
    notes: 'Notes',
    
    // Absences
    sick_leave: 'Sick Leave',
    personal: 'Personal',
    other: 'Other',
    absence_type: 'Absence Type',
    register_absence: 'Register Absence',
    
    // Locations
    add_location: 'Add Location',
    address: 'Address',
    latitude: 'Latitude',
    longitude: 'Longitude',
    radius: 'Radius (meters)',
    
    // Reports
    generate_report: 'Generate Report',
    date_range: 'Date Range',
    export_excel: 'Export Excel',
    export_csv: 'Export CSV',
    worked_hours: 'Worked Hours',
    extra_hours: 'Extra Hours',
    night_hours: 'Night Hours',
    sunday_holiday_hours: 'Sunday/Holiday Hours',
    
    // Kiosk
    enter_pin: 'Enter your PIN',
    clock_action: 'Select an action',
    success: 'Success',
    error: 'Error',
    invalid_pin: 'Invalid PIN',
    record_saved: 'Record saved',
    
    // Roles
    admin: 'Administrator',
    supervisor: 'Supervisor',
    worker: 'Worker',
    inspector: 'Inspector',
    
    // Messages
    confirm_delete: 'Are you sure you want to delete?',
    saved_successfully: 'Saved successfully',
    deleted_successfully: 'Deleted successfully',
    error_occurred: 'An error occurred',
    no_results: 'No results',
    
    // Time
    today: 'Today',
    yesterday: 'Yesterday',
    this_week: 'This Week',
    this_month: 'This Month',
    hours: 'hours',
    minutes: 'minutes',
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('language') || 'es';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  const t = (key) => {
    return translations[language]?.[key] || translations['es'][key] || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'es' ? 'en' : 'es');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
